import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row", "count", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const query = (this.hasInputTarget ? this.inputTarget.value : "").toString().trim().toLowerCase()
    let visibleCount = 0

    this.rowTargets.forEach((row) => {
      const haystack = (row.dataset.listFilterTextValue || "").toLowerCase()
      const visible = query.length === 0 || haystack.includes(query)
      row.classList.toggle("d-none", !visible)
      visibleCount += visible ? 1 : 0
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = String(visibleCount)
    }
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", visibleCount > 0)
    }
  }
}
